var map = {
	"./black/bofang.png": "+3Jh",
	"./blue/bofang.png": "2tL5",
	"./white/bofang.png": "beZE"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9888";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/bofang\.png$
// module id = 9888
// module chunks = 24